import {
    getL1CategoryIdBySeoName,
    getL2CategoryIdBySeoName,
} from '@gumtree/shared/src/util/category-mapping';

import { SellersOtherAdsState } from '@gumtree/shared/src/model/seller-other-ads-model';
import { AD } from '@gumtree/shared/src/model/generic.model';

const initialState: SellersOtherAdsState = {
    sellersOtherAds: [
        {
            additionalImageUrls: [],
            imageUrl: '',
            adItemType: '',
            attributes: [],
            categoryId: 0,
            course: false,
            date: 0,
            featured: false,
            hasVideo: false,
            id: 0,
            imageIds: [],
            l1CategoryId: getL1CategoryIdBySeoName('for-sale'),
            l2CategoryId: getL2CategoryIdBySeoName('miscellaneous-goods'),
            location: '',
            numberOfImages: 0,
            path: '',
            postedDate: '',
            premium: false,
            price: '0',
            proAccount: false,
            sellerId: 0,
            shortDescription: '',
            standout: false,
            status: 'LIVE',
            title: '',
            urgent: false,
            priceInPounds: '',
        },
    ],
    numFound: 0,
    createdBy: '',
};

export const UPDATE_SELLER_ADS = 'UPDATE_SELLER_ADS';

export const updateSellerAds: AD<typeof UPDATE_SELLER_ADS, Partial<SellersOtherAdsState>> = (
    payload
) => ({
    type: UPDATE_SELLER_ADS,
    payload,
});

export default (state: SellersOtherAdsState = initialState, action): SellersOtherAdsState =>
    action.type === UPDATE_SELLER_ADS ? { ...state, ...action.payload } : state;
